import { useContext } from 'react';
import type { UserPermissionsContextValue } from '../types';
import { UserPermissionsContext } from '../UserPermissionsProvider';

/**
 * Facade hook to access user permissions context
 * Throws if used outside of UserPermissionsProvider
 *
 * @example
 * ```tsx
 * const { license } = useUserPermissions();
 * ```
 */
const useUserPermissions = (): UserPermissionsContextValue => {
  const context = useContext(UserPermissionsContext);

  if (!context) {
    throw new Error('useUserPermissions must be used within a UserPermissionsProvider');
  }

  return context;
};

export default useUserPermissions;
